<template>
  <v-app-bar
    v-if="isLoggedIn"
    app
    fixed
    elevation="2"
    color="white"
    height="64"
    style="
      z-index: 1000;
    "
  >
    <!-- Logo e título da aplicação -->
    <div class="d-flex align-center">
      <div class="d-flex flex-column">
        <span class="text-h6 font-weight-medium" style="color: #1976d2;">
          {{ currentPageTitle }}
        </span>
        <div 
          v-if="showDropdowns && (selectedUnitName || (!isGoalsForecastPage && periodDate))"
          class="text-caption font-weight-regular subtitle"
          style="color: #000000; line-height: 1.2;"
        >
          <div v-if="!isGoalsForecastPage" class="period">{{ periodDate || 'Período invalido' }}</div>
          <div class="unit">{{ isGoalsForecastPage ? selectedUnitName || 'Sem unidade selecionada' : `/ ${selectedUnitName || 'Sem unidade selecionada'}` }}</div>
        </div>
      </div>
    </div>

    <v-spacer></v-spacer>

    <Dropdown
      v-if="showDropdowns"
      :value="unitMeasure"
      :options="unitMeasureOptions"
      @input="onChangeUnitMeasure"
      class="chart-type-select"
      style="min-width: clamp(200px, 200px, 250px);"
    />

    <Dropdown
      v-if="showPeriodDropdown"
      :value="period"
      :options="periodeOptions"
      @input="onPeriodSelect"
      class="chart-type-select"
      style="min-width: 180px; max-width: 220px;"
    />
    
    <!-- Área direita - Ações do usuário -->
    <div class="d-flex align-center">
      <!-- Menu do usuário -->
      <v-menu
        v-model="showUserMenu"
        :close-on-content-click="false"
        offset-y
        left
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            v-bind="attrs"
            v-on="on"
            class="d-flex align-center"
          >
            <v-avatar
              size="32"
              class="mr-2"
              color="primary"
            >
              <v-img
                v-if="getCurrentUser.data.metadata.imageURL && getCurrentUser.data.metadata.imageURL.length > 0"
                :src="getCurrentUser.data.metadata.imageURL"
              />
              <v-img
                v-else
                src="https://cdn.pixabay.com/photo/2013/07/13/12/07/avatar-159236_640.png"
              />
            </v-avatar>
            <span class="text-body-2 font-weight-medium" style="color: #333;">
              {{ getCurrentUserName }}
            </span>
            <v-icon class="ml-1">mdi-chevron-down</v-icon>
          </v-btn>
        </template>

        <v-card min-width="200" elevation="3">
          <v-list dense>
            <v-list-item>
              <v-list-item-avatar size="40">
                <v-img
                  v-if="getCurrentUser.data.metadata.imageURL && getCurrentUser.data.metadata.imageURL.length > 0"
                  :src="getCurrentUser.data.metadata.imageURL"
                />
                <v-img
                  v-else
                  src="https://cdn.pixabay.com/photo/2013/07/13/12/07/avatar-159236_640.png"
                />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-body-2 font-weight-medium">
                  {{ getCurrentUserName }}
                </v-list-item-title>
                <v-list-item-subtitle class="text-caption" style="color: #666;">
                  {{ getCurrentUserRank }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <!-- <v-list-item @click="goToProfile">
              <v-list-item-icon>
                <v-icon size="20">mdi-account</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="text-body-2">Perfil</v-list-item-title>
            </v-list-item> -->

            <!-- <v-list-item @click="goToSettings">
              <v-list-item-icon>
                <v-icon size="20">mdi-cog</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="text-body-2">Configurações</v-list-item-title>
            </v-list-item> -->

            <v-list-item
              href="https://fozsustentavel.com.br/terms-of-use/"
              target="_blank"
              rel="noopener noreferrer"
              link style="text-decoration: none; color: inherit;"
              >
              <v-list-item-icon>
                <v-icon size="20">mdi-file-document-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="text-body-2">Termos de Uso</v-list-item-title>
            </v-list-item>

            <v-list-item
              href="https://fozsustentavel.com.br/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
              link style="text-decoration: none; color: inherit;"
              >
              <v-list-item-icon>
                <v-icon size="20">mdi-shield-account-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="text-body-2">Políticas de Privacidade</v-list-item-title>
            </v-list-item>


            <v-divider></v-divider>

            <v-list-item @click="handleLogout" style="color: #f44336;">
              <v-list-item-icon>
                <v-icon size="20" color="error">mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="text-body-2" style="color: #f44336;">
                Sair
              </v-list-item-title>
            </v-list-item>
          </v-list>

        </v-card>
      </v-menu>
    </div>

    <v-dialog
      ref="dialog"
      v-if="modalDatePicker && !isGoalsForecastPage"
      v-model="modalDatePicker"
      persistent
      width="290px"
    >
      <v-date-picker
        v-model="date"
        :type="typePicker" 
        :max="period === 'hour' ? new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().substring(0, 10) : null"
        min="1950-01-01"
        :range="rangePicker"
        scrollable
        :style="{height: '500px',maxHeight: this.typePicker == 'month' ? '440px' : '500px'}"
      >
        <v-spacer></v-spacer>
        <v-btn
          text
          color="primary"
          @click="modalDatePicker = false"
        >
          Cancel
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="saveIntervalDate"
        >
          OK
        </v-btn>
      </v-date-picker>
    </v-dialog>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Dropdown from '@/components/DropMenus/Dropdown.vue'
import Utils from '@/scripts/Utils';
import { showErrorSnackBar, showSuccessSnackBar, showInfoSnackBar } from "@/utils/SnackBartHelper";
import UnitsService from '@/services/server/UnitsService';

export default {
  name: "TopBar",
  components: {
    Dropdown
  },
  data: () => ({
    showUserMenu: false,
    currentPageTitle: "",
    periodDate: "",
    unitMeasureOptions:[
      { text: 'Metros cúbicos(m³)', value: 'm3' },
      { text: 'Litros(L)', value: 'liters' }
    ],
    period:"estimed",
    allPeriodeOptions:[
      { text: 'Meses do ano', value: 'month' },
      { text: 'Dias do mês', value: 'day' },
      { text: 'Escolher dias', value: 'interval' },
      { text: 'Horas do dia', value: 'hour' },
      { text: 'Últimos 7 dias', value: '7days' },
      { text: 'Estimado', value: 'estimed' },
    ],
    periodeOptions: [
      { text: 'Estimado', value: 'estimed' }
    ],
    modalDatePicker:false,
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    typePicker:'date',
    rangePicker: false,
    // Evita recursividade quando o período estimado atualiza a unidade no Vuex
    isHandlingEstimatedPeriod: false,
  }),
  computed: {
    ...mapGetters([
      "isLoggedIn",
      "getCurrentUser",
      "getCurrentUserName",
      "getCurrentUserRank",
      "getSelectedUnit",
      "getSelectedUnits",
      "unitMeasure"
    ]),
    selectedUnitName() {
      const unitsArray = this.getSelectedUnits || [];

      // Quando houver mais de uma unidade selecionada, exibe texto genérico
      if (Array.isArray(unitsArray) && unitsArray.length > 1) {
        return 'Várias unidades selecionadas';
      }

      const unit = this.getSelectedUnit || unitsArray[0];
      const name = unit?.title || unit?.name || '';
      return name;
    },
    showDropdowns() {
      return this.$route.path === '/dashboard' || this.$route.path === '/consumption' || this.$route.path === '/consumption-by-tariff'
        || this.$route.path === '/alertas' || this.$route.path === '/reservoir' || this.$route.path === '/goals-forecasts';
    },
    showPeriodDropdown() {
      return this.showDropdowns && !this.isGoalsForecastPage;
    },
    isGoalsForecastPage() {
      return this.$route.path === '/goals-forecasts';
    },
    isReservoirPage() {
      return this.$route.path === '/reservoir';
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        this.updatePageTitle(to);
      }
    },
    period(val) {
      if (this.isGoalsForecastPage) {
        this.modalDatePicker = false;
        return;
      }

      this.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
      if(val == 'month') {
        this.typePicker = "month"
        this.rangePicker = true
      } else if(val == 'day') {
        this.typePicker = "month"
        this.rangePicker = false
      } else if(val == 'interval') {
        this.typePicker = "date"
        this.rangePicker = true
      } else {
        this.typePicker = "date"
        this.rangePicker = false
      }
      if(val != 'estimed' && val != '7days') this.modalDatePicker = true;
      else this.handlePeriodChange(val);
    },
    currentPageTitle: {
      immediate: true,
      handler(val) {
        if (val === 'Dashboard') {
          this.periodeOptions = [
            { text: 'Estimado', value: 'estimed' }
          ];
          this.period = 'estimed';
      } else if (this.isGoalsForecastPage) {
          this.periodeOptions = [];
          this.modalDatePicker = false;
        } else if (this.isReservoirPage) {
          this.periodeOptions = [...this.allPeriodeOptions];
          this.period = '7days';
        } else {
          this.periodeOptions = [...this.allPeriodeOptions];
        }
      }
    },
    getSelectedUnit: {
      immediate: true,
      handler(unit) {
        const unitsArray = this.getSelectedUnits || [];
        // Se não houver nenhuma unidade selecionada (nem única nem na lista),
        // só limpamos o período quando o tipo for "estimado" (pois depende da unidade).
        // Para outros períodos (ex.: "Últimos 7 dias"), mantemos o período escolhido.
        if (!unit && (!Array.isArray(unitsArray) || unitsArray.length === 0)) {
          if (this.period === 'estimed') {
            this.periodDate = '';
            this.SET_SELECTED_PERIOD_VALUE({ period: null, startDate: null, endDate: null });
          }
          return;
        }

        // Quando período é estimado, só buscar datas se ainda não tiver estimateStartDate/estimateEndDate
        if (
          this.period === "estimed" &&
          !this.isHandlingEstimatedPeriod &&
          unit &&
          !unit.estimateStartDate &&
          !unit.estimateEndDate
        ) {
          this.handlePeriodChange(this.period);
        }
      }
    },
    getSelectedUnits: {
      immediate: true,
      handler(units) {
        const unit = this.getSelectedUnit;
        const hasUnitsArray = Array.isArray(units) && units.length > 0;

        // Se não houver nenhuma unidade selecionada (nem única nem na lista),
        // só limpamos o período quando o tipo for "estimado" (pois depende da unidade).
        // Para outros períodos (ex.: "Últimos 7 dias"), mantemos o período escolhido.
        if (!unit && !hasUnitsArray) {
          if (this.period === 'estimed') {
            this.periodDate = '';
            this.SET_SELECTED_PERIOD_VALUE({ period: null, startDate: null, endDate: null });
          }
          return;
        }

        // Fallback: se não houver getSelectedUnit definido, mas existir exatamente 1 unidade no array,
        // e ela ainda não tiver estimateStartDate/estimateEndDate, buscar período estimado
        if (
          this.period === "estimed" &&
          !this.isHandlingEstimatedPeriod &&
          !unit &&
          hasUnitsArray &&
          units.length === 1 &&
          !units[0].estimateStartDate &&
          !units[0].estimateEndDate
        ) {
          this.handlePeriodChange(this.period);
        }
      }
    }
  },
  created() {
    this.handlePeriodChange(this.period);
  },
  methods: {
    ...mapActions(["logout"]),
    ...mapMutations(["SET_UNIT_MEASURE", "SET_SELECTED_PERIOD_VALUE", "SET_SELECTED_UNIT"]),

    updatePageTitle(route) {
      // Título da página atual baseado na rota
      const routeTitles = {
        // Rotas principais
        '/': 'Central Foz',
        '/login': 'Login',
        '/dashboard': 'Dashboard',
        '/consumption': 'Consumo',
        '/consumption-by-tariff': 'Consumo por Tarifa',
        '/reservoir': 'Reservatório',
        '/units': 'Unidades',
        '/projects': 'Projetos',
        '/called': 'Chamados',
        '/goals-forecasts': 'Metas',
        '/report': 'Relatórios',
        '/settings': 'Configurações',
        '/solutions': 'Soluções',
        
        // Alertas
        '/alertas': 'Alertas',
        '/alertas/cosumption': 'Alertas - Consumo',
        '/alertas/telemetry': 'Alertas - Telemetria',
        '/alertas/goal': 'Alertas - Metas',
        
        // Water Fix
        '/water-fix': 'Water Fix',
        '/water-fix/new-proposal': 'Water Fix - Nova Proposta',
        '/water-fix/consult-proposal': 'Water Fix - Consultar Proposta',
        
        // Water Scan
        '/water-scan': 'Water Scan',
        '/water-scan/new-proposal': 'Water Scan - Nova Proposta',
        '/water-scan/consult-proposal': 'Water Scan - Consultar Proposta',
        
        // Configurações
        '/settings/contract': 'Configurações - Contratos',
        '/settings/signatures': 'Configurações - Assinaturas',
        '/settings/users': 'Configurações - Usuários',
        '/settings/alerts': 'Configurações - Alertas',
        '/settings/permissions': 'Configurações - Permissões',
        '/settings/waterProbes': 'Configurações - Sondas',
        '/settings/hydrometers': 'Configurações - Hidrômetros',
        '/settings/modems': 'Configurações - Modems',
        '/settings/water_authorities': 'Configurações - Concessionárias',
        
        // Soluções
        '/solutions/solutions_services': 'Soluções - Serviços',
        '/solutions/group': 'Soluções - Grupos',
        '/solutions/point': 'Soluções - Pontos',
        
        // Relatórios
        '/report/economy': 'Relatórios - Economia',
        '/report/called': 'Relatórios - Chamados',
        '/report/alerts': 'Relatórios - Alertas',
        '/report/telemetry': 'Relatórios - Telemetria',
        
        // Outros
        '/signatures': 'Assinaturas',
        '/404': 'Página não encontrada',
        '/forbidden': 'Acesso negado'
      };

      // Verificar se a rota atual está no mapeamento
      if (routeTitles[route.path]) {
        this.currentPageTitle = routeTitles[route.path];
      } else {
        // Para rotas dinâmicas com parâmetros
        if (route.path.includes('/projects/')) {
          this.currentPageTitle = 'Detalhes do Projeto';
        } else if (route.path.includes('/water-fix/consult-proposal/')) {
          this.currentPageTitle = 'Water Fix - Consultar Proposta';
        } else if (route.path.includes('/water-scan/consult-proposal/')) {
          this.currentPageTitle = 'Water Scan - Consultar Proposta';
        } else if (route.path.includes('/signatures/')) {
          this.currentPageTitle = 'Assinatura';
        } else if (route.path.includes('/settings/water_authorities/')) {
          this.currentPageTitle = 'Configurações - Concessionárias';
        } else {
          // Fallback para rotas não mapeadas - tentar extrair do path
          const pathParts = route.path.split('/').filter(part => part);
          if (pathParts.length > 0) {
            const lastPart = pathParts[pathParts.length - 1];
            // Capitalizar primeira letra e substituir hífens por espaços
            this.currentPageTitle = lastPart
              .replace(/-/g, ' ')
              .replace(/\b\w/g, l => l.toUpperCase());
          } else {
            this.currentPageTitle = 'Central Foz';
          }
        }
      }
    },

    goToProfile() {
      this.showUserMenu = false;
      // Implementar navegação para perfil
      this.$router.push('/profile');
    },

    goToSettings() {
      this.showUserMenu = false;
      // Implementar navegação para configurações
      this.$router.push('/configs');
    },

    async handleLogout() {
      this.showUserMenu = false;
      this.$emit('logout');
    },

    onChangeUnitMeasure(val) {
      this.SET_UNIT_MEASURE(val);
      
    },

    async handlePeriodChange(val, selectedDate) {

      const now = new Date();
      const pad = n => n.toString().padStart(2, '0');
      const format = date => {
        if (!date) return '';
        if (typeof date === 'number') {
          if (date.toString().length === 10) date = date * 1000;
          date = new Date(date);
        } else if (typeof date === 'string' && !isNaN(Number(date))) {
          let num = Number(date);
          if (date.length === 10) num = num * 1000;
          date = new Date(num);
        } else if (typeof date === 'string') {
          const d = new Date(date);
          if (!isNaN(d)) date = d;
        }
        if (!(date instanceof Date) || isNaN(date)) return '';
        return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;
      };
      let periodString = '';
      let startDate = null;
      let endDate = null;
      // Na página de Alertas só selectedUnits é atualizado; usar primeira unidade como fallback para período estimado
      const unit = this.getSelectedUnit || this.getSelectedUnits?.[0] || {};
      let dateToUse = selectedDate || this.date;
      switch (val) {
        case '7days': {
          const end = Utils.subtractDate(new Date(now),1,'day')
          const start = new Date(now);
          start.setDate(now.getDate() - 7);
          periodString = `${format(start)} - ${format(end)}`;
          startDate = start;
          endDate = end;
          break;
        }
        case 'month': {
          // Se dateToUse for array e tiver apenas um item, redireciona para 'day'
          if(dateToUse.length == 1) dateToUse = dateToUse[0];
          if(!Array.isArray(dateToUse)){
            this.handlePeriodChange("day", dateToUse);
            return;
          }
          const dateA = new Date(dateToUse[0]);
          const dateB = new Date(dateToUse[1]);
          if (dateA.getTime() <= dateB.getTime()) {
            startDate = dateA;
            endDate = dateB;
          } else {
            startDate = dateB;
            endDate = dateA;
          }
          let yearStart = startDate.getFullYear();
          let monthStart = startDate.getMonth();
          let yearEnd = endDate.getFullYear();
          let monthEnd = endDate.getMonth();
          const start = new Date(yearStart, monthStart +1, 1); // Dia 1 do mês
          let end = null;
          if(now.getMonth() == endDate.getMonth()) {
            end = new Date(yearEnd, monthEnd +1, 0); // Último dia do mês
          } else {
            end = new Date(yearEnd, monthEnd +2, 0); // Último dia do mês
          }
          periodString = `${format(start)} - ${format(end)}`;
          startDate = start;
          endDate = end;
          break;
        }
        case 'day': {
          let [year, month, day] = dateToUse.split('-');
          year = parseInt(year);
          month = parseInt(month) - 1; 
          day = parseInt(day);
          const end = new Date(year, month, 31);
          let startYear = year;
          let start = new Date(startYear, month, 1);
          if (start.getMonth() !== month) {
            start = new Date(startYear, month + 1, 0);
          }
          periodString = `${format(start)} - ${format(end)}`;
          startDate = start;
          endDate = end;
          break;
        }
        case 'hour': {
          let [year, month, day] = dateToUse.split('-');
          year = parseInt(year);
          month = parseInt(month) - 1; 
          day = parseInt(day);
          const end = new Date(year, month, day);
          let startYear = year;
          let start = new Date(startYear, month, day);
          if (start.getMonth() !== month) {
            start = new Date(startYear, month + 1, 0);
          }
          periodString = `${format(start)} - ${format(end)}`;
          startDate = start;
          endDate = end;
          break;
        }
        case 'interval': {
          if(dateToUse.length == 1) dateToUse = dateToUse[0];
          if(!Array.isArray(dateToUse)){
            this.handlePeriodChange("hour", dateToUse);
            return;
          }
          const dateA = new Date(dateToUse[0]);
          const dateB = new Date(dateToUse[1]);
          if (dateA.getTime() <= dateB.getTime()) {
            startDate = dateA;
            endDate = dateB;
          } else {
            startDate = dateB;
            endDate = dateA;
          }
          startDate.setDate(startDate.getDate() + 1);
          endDate.setDate(endDate.getDate() + 1);
          startDate = new Date(startDate);
          endDate = new Date(endDate);
          periodString = `${format(startDate)} - ${format(endDate)}`;
          break;
        }
        case 'estimed': {
          // Evita recursividade caso já esteja tratando período estimado
          if (this.isHandlingEstimatedPeriod) {
            break;
          }
          this.isHandlingEstimatedPeriod = true;
          try {
          if (unit.id) {
            // Se houver mais de uma unidade selecionada ao mesmo tempo, não é possível calcular período estimado
            const unitsArray = this.getSelectedUnits || [];
            if (Array.isArray(unitsArray) && unitsArray.length > 1) {
              break;
            }
            try {
              const res = await UnitsService.readingPeriodByUnit(unit.id);
              const periodData = res?.data?.data?.period;
              const startStr = periodData?.start;
              const endStr = periodData?.end;
              if (startStr && endStr) {
                const parseIsoDate = (str) => {
                  const d = new Date(str);
                  return !isNaN(d) ? d : null;
                };
                const rawStart = parseIsoDate(startStr);
                const rawEnd = parseIsoDate(endStr);
                if (rawStart && rawEnd) {
                  // Normaliza para início do dia (start) e fim do dia (end) no fuso local,
                  // para que o payload enviado no filter tenha startDate 1 dia correto e endDate incluindo o último dia.
                  startDate = new Date(rawStart.getFullYear(), rawStart.getMonth(), rawStart.getDate(), 0, 0, 0, 0);
                  endDate = new Date(rawEnd.getFullYear(), rawEnd.getMonth(), rawEnd.getDate(), 23, 59, 59, 999);
                  periodString = `${format(startDate)} - ${format(endDate)}`;
                  this.SET_SELECTED_UNIT({
                    ...unit,
                    estimateStartDate: format(startDate),
                    estimateEndDate: format(endDate)
                  });
                } else {
                  showInfoSnackBar("A unidade selecionada não possui data de leitura");
                }
              } else {
                showInfoSnackBar("A unidade selecionada não possui data de leitura");
              }
            } catch (err) {
              console.error('Erro ao buscar período estimado da unidade:', err);
              showInfoSnackBar("Não foi possível carregar o período estimado da unidade");
            }
          } else {
            periodString = '';
          }
          } finally {
            this.isHandlingEstimatedPeriod = false;
          }
          break;
        }
        default: {
          periodString = '';
          break;
        }
      }
      if (!(startDate instanceof Date) || isNaN(startDate)) startDate = null;
      if (!(endDate instanceof Date) || isNaN(endDate)) endDate = null;
      this.periodDate = periodString;
      this.SET_SELECTED_PERIOD_VALUE({ period: val, startDate, endDate });
    },

    saveIntervalDate() {
      this.modalDatePicker = false;
      this.handlePeriodChange(this.period, this.date);
    },

    onPeriodSelect(val) {
      if (this.isGoalsForecastPage) return;
      // Permite reabrir o date picker mesmo se o valor for igual ao atual
      if (this.period === val) {
        if(val !== 'estimed' && val !== '7days') {
          this.modalDatePicker = true;
        }
        this.handlePeriodChange(val);
      } else {
        this.period = val;
      }
    }
  }
};
</script>

<style scoped>
.v-app-bar {
  border-bottom: 1px solid #e0e0e0;
}

/* Responsividade */
@media (max-width: 768px) {
  .v-app-bar {
    height: 56px !important;
  }
  
  .text-h6 {
    font-size: 1.1rem !important;
  }
}

@media (max-width: 480px) {
  .v-app-bar {
    height: 48px !important;
  }
  
  .text-h6 {
    font-size: 1rem !important;
  }
}

/* Estilos para o menu do usuário */
.v-menu__content {
  border-radius: 8px;
}

.v-list-item:hover {
  background-color: #f5f5f5;
}

/* Estilos para os botões da TopBar */
.v-btn--icon {
  border-radius: 50%;
}

.v-btn--icon:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

/* Estilos para o avatar do usuário */
.v-avatar {
  border: 2px solid #e0e0e0;
}

/* Estilos para o logo */
.v-img {
  transition: transform 0.2s ease;
}

.v-img:hover {
  transform: scale(1.05);
}

.chart-type-select {
  margin-left: 16px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 1px 4px rgba(25, 118, 210, 0.08);
  font-family: Manrope, sans-serif;
  font-size: 15px;
  font-weight: 500;
  min-width: 180px;
  max-width: 220px;
}

.subtitle {
  display: flex;
  flex-direction: row;
  gap: 8px; /* Espaço entre as divs, ajuste como quiser */
  align-items: center;
}
.period{
  color: #000;
  font-family: Manrope;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 138.943%; 
  
}
.unit{
  color: #000;
  font-family: Manrope;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 138.943%; 
  opacity: 0.4;
}
</style> 
